/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type Agency = typeof Agency[keyof typeof Agency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Agency = {
  action: 'action',
  'administration-office-executive-office-of-the-president': 'administration-office-executive-office-of-the-president',
  'administrative-conference-of-the-united-states': 'administrative-conference-of-the-united-states',
  'administrative-office-of-united-states-courts': 'administrative-office-of-united-states-courts',
  'advisory-council-on-historic-preservation': 'advisory-council-on-historic-preservation',
  'advocacy-and-outreach-office': 'advocacy-and-outreach-office',
  'agency-for-healthcare-research-and-quality': 'agency-for-healthcare-research-and-quality',
  'agency-for-international-development': 'agency-for-international-development',
  'agency-for-toxic-substances-and-disease-registry': 'agency-for-toxic-substances-and-disease-registry',
  'aging-administration': 'aging-administration',
  'agricultural-marketing-service': 'agricultural-marketing-service',
  'agricultural-research-service': 'agricultural-research-service',
  'agriculture-department': 'agriculture-department',
  'air-force-department': 'air-force-department',
  'air-quality-national-commission': 'air-quality-national-commission',
  'air-transportation-stabilization-board': 'air-transportation-stabilization-board',
  'alaska-power-administration': 'alaska-power-administration',
  'alcohol-and-tobacco-tax-and-trade-bureau': 'alcohol-and-tobacco-tax-and-trade-bureau',
  'alcohol-tobacco-firearms-and-explosives-bureau': 'alcohol-tobacco-firearms-and-explosives-bureau',
  'american-battle-monuments-commission': 'american-battle-monuments-commission',
  'amtrak-reform-council': 'amtrak-reform-council',
  'animal-and-plant-health-inspection-service': 'animal-and-plant-health-inspection-service',
  'antitrust-division': 'antitrust-division',
  'antitrust-modernization-commission': 'antitrust-modernization-commission',
  'appalachian-regional-commission': 'appalachian-regional-commission',
  'appalachian-states-low-level-radioactive-waste-commission': 'appalachian-states-low-level-radioactive-waste-commission',
  'architect-of-the-capitol': 'architect-of-the-capitol',
  'architectural-and-transportation-barriers-compliance-board': 'architectural-and-transportation-barriers-compliance-board',
  'arctic-research-commission': 'arctic-research-commission',
  'armed-forces-retirement-home': 'armed-forces-retirement-home',
  'arms-control-and-disarmament-agency': 'arms-control-and-disarmament-agency',
  'army-department': 'army-department',
  'assassination-records-review-board': 'assassination-records-review-board',
  'barry-m-goldwater-scholarship-and-excellence-in-education-foundation': 'barry-m-goldwater-scholarship-and-excellence-in-education-foundation',
  'benefits-review-board': 'benefits-review-board',
  'bipartisan-commission-on-entitlement-and-tax-reform': 'bipartisan-commission-on-entitlement-and-tax-reform',
  'board-of-directors-of-the-hope-for-homeowners-program': 'board-of-directors-of-the-hope-for-homeowners-program',
  'bonneville-power-administration': 'bonneville-power-administration',
  'broadcasting-board-of-governors': 'broadcasting-board-of-governors',
  'bureau-of-the-fiscal-service': 'bureau-of-the-fiscal-service',
  'census-bureau': 'census-bureau',
  'census-monitoring-board': 'census-monitoring-board',
  'centers-for-disease-control-and-prevention': 'centers-for-disease-control-and-prevention',
  'centers-for-medicare-medicaid-services': 'centers-for-medicare-medicaid-services',
  'central-intelligence-agency': 'central-intelligence-agency',
  'chemical-safety-and-hazard-investigation-board': 'chemical-safety-and-hazard-investigation-board',
  'child-support-enforcement-office': 'child-support-enforcement-office',
  'children-and-families-administration': 'children-and-families-administration',
  'christopher-columbus-quincentenary-jubilee-commission': 'christopher-columbus-quincentenary-jubilee-commission',
  'civil-rights-cold-case-records-review-board': 'civil-rights-cold-case-records-review-board',
  'civil-rights-commission': 'civil-rights-commission',
  'coast-guard': 'coast-guard',
  'commerce-department': 'commerce-department',
  'commercial-space-transportation-office': 'commercial-space-transportation-office',
  'commission-of-fine-arts': 'commission-of-fine-arts',
  'commission-on-immigration-reform': 'commission-on-immigration-reform',
  'commission-on-protecting-and-reducing-government-secrecy': 'commission-on-protecting-and-reducing-government-secrecy',
  'commission-on-review-of-overseas-military-facility-structure-of-the-united-states': 'commission-on-review-of-overseas-military-facility-structure-of-the-united-states',
  'commission-on-structural-alternatives-for-the-federal-courts-of-appeals': 'commission-on-structural-alternatives-for-the-federal-courts-of-appeals',
  'commission-on-the-advancement-of-federal-law-enforcement': 'commission-on-the-advancement-of-federal-law-enforcement',
  'commission-on-the-bicentennial-of-the-united-states-constitution': 'commission-on-the-bicentennial-of-the-united-states-constitution',
  'commission-on-the-future-of-the-united-states-aerospace-industry': 'commission-on-the-future-of-the-united-states-aerospace-industry',
  'commission-on-the-social-security-notch-issue': 'commission-on-the-social-security-notch-issue',
  'committee-for-purchase-from-people-who-are-blind-or-severely-disabled': 'committee-for-purchase-from-people-who-are-blind-or-severely-disabled',
  'committee-for-the-implementation-of-textile-agreements': 'committee-for-the-implementation-of-textile-agreements',
  'commodity-credit-corporation': 'commodity-credit-corporation',
  'commodity-futures-trading-commission': 'commodity-futures-trading-commission',
  'community-development-financial-institutions-fund': 'community-development-financial-institutions-fund',
  'community-living-administration': 'community-living-administration',
  'competitiveness-policy-council': 'competitiveness-policy-council',
  'comptroller-of-the-currency': 'comptroller-of-the-currency',
  'congressional-budget-office': 'congressional-budget-office',
  'consumer-financial-protection-bureau': 'consumer-financial-protection-bureau',
  'consumer-product-safety-commission': 'consumer-product-safety-commission',
  'cooperative-state-research-education-and-extension-service': 'cooperative-state-research-education-and-extension-service',
  'coordinating-council-on-juvenile-justice-and-delinquency-prevention': 'coordinating-council-on-juvenile-justice-and-delinquency-prevention',
  'copyright-office-library-of-congress': 'copyright-office-library-of-congress',
  'copyright-royalty-board': 'copyright-royalty-board',
  'copyright-royalty-judges': 'copyright-royalty-judges',
  'corporation-for-national-and-community-service': 'corporation-for-national-and-community-service',
  'council-of-the-inspectors-general-on-integrity-and-efficiency': 'council-of-the-inspectors-general-on-integrity-and-efficiency',
  'council-on-environmental-quality': 'council-on-environmental-quality',
  'counsel-to-the-president': 'counsel-to-the-president',
  'court-services-and-offender-supervision-agency-for-the-district-of-columbia': 'court-services-and-offender-supervision-agency-for-the-district-of-columbia',
  'crime-and-security-in-u-s-seaports-interagency-commission': 'crime-and-security-in-u-s-seaports-interagency-commission',
  'customs-service': 'customs-service',
  'defense-acquisition-regulations-system': 'defense-acquisition-regulations-system',
  'defense-base-closure-and-realignment-commission': 'defense-base-closure-and-realignment-commission',
  'defense-contract-audit-agency': 'defense-contract-audit-agency',
  'defense-criminal-investigative-service': 'defense-criminal-investigative-service',
  'defense-department': 'defense-department',
  'defense-information-systems-agency': 'defense-information-systems-agency',
  'defense-intelligence-agency': 'defense-intelligence-agency',
  'defense-investigative-service': 'defense-investigative-service',
  'defense-logistics-agency': 'defense-logistics-agency',
  'defense-mapping-agency': 'defense-mapping-agency',
  'defense-nuclear-facilities-safety-board': 'defense-nuclear-facilities-safety-board',
  'defense-special-weapons-agency': 'defense-special-weapons-agency',
  'delaware-river-basin-commission': 'delaware-river-basin-commission',
  'denali-commission': 'denali-commission',
  'disability-employment-policy-office': 'disability-employment-policy-office',
  'drug-enforcement-administration': 'drug-enforcement-administration',
  'economic-analysis-bureau': 'economic-analysis-bureau',
  'economic-analysis-staff': 'economic-analysis-staff',
  'economic-development-administration': 'economic-development-administration',
  'economic-research-service': 'economic-research-service',
  'economics-and-statistics-administration': 'economics-and-statistics-administration',
  'education-department': 'education-department',
  'election-assistance-commission': 'election-assistance-commission',
  'electronic-commerce-advisory-commission': 'electronic-commerce-advisory-commission',
  'emergency-oil-and-gas-guaranteed-loan-board': 'emergency-oil-and-gas-guaranteed-loan-board',
  'emergency-steel-guarantee-loan-board': 'emergency-steel-guarantee-loan-board',
  'employee-benefits-security-administration': 'employee-benefits-security-administration',
  'employees-compensation-appeals-board': 'employees-compensation-appeals-board',
  'employment-and-training-administration': 'employment-and-training-administration',
  'employment-standards-administration': 'employment-standards-administration',
  'energy-and-environmental-policy-office': 'energy-and-environmental-policy-office',
  'energy-department': 'energy-department',
  'energy-efficiency-and-renewable-energy-office': 'energy-efficiency-and-renewable-energy-office',
  'energy-information-administration': 'energy-information-administration',
  'energy-policy-and-new-uses-office': 'energy-policy-and-new-uses-office',
  'energy-research-office': 'energy-research-office',
  'engineers-corps': 'engineers-corps',
  'engraving-and-printing-bureau': 'engraving-and-printing-bureau',
  'environment-office-energy-department': 'environment-office-energy-department',
  'environmental-protection-agency': 'environmental-protection-agency',
  'equal-employment-opportunity-commission': 'equal-employment-opportunity-commission',
  'executive-council-on-integrity-and-efficiency': 'executive-council-on-integrity-and-efficiency',
  'executive-office-for-immigration-review': 'executive-office-for-immigration-review',
  'executive-office-of-the-president': 'executive-office-of-the-president',
  'export-administration-bureau': 'export-administration-bureau',
  'export-import-bank': 'export-import-bank',
  'family-assistance-office': 'family-assistance-office',
  'farm-credit-administration': 'farm-credit-administration',
  'farm-credit-system-insurance-corporation': 'farm-credit-system-insurance-corporation',
  'farm-production-and-conservation-business-center': 'farm-production-and-conservation-business-center',
  'farm-service-agency': 'farm-service-agency',
  'federal-accounting-standards-advisory-board': 'federal-accounting-standards-advisory-board',
  'federal-acquisition-regulation-system': 'federal-acquisition-regulation-system',
  'federal-aviation-administration': 'federal-aviation-administration',
  'federal-bureau-of-investigation': 'federal-bureau-of-investigation',
  'federal-communications-commission': 'federal-communications-commission',
  'federal-contract-compliance-programs-office': 'federal-contract-compliance-programs-office',
  'federal-council-on-the-arts-and-the-humanities': 'federal-council-on-the-arts-and-the-humanities',
  'federal-crop-insurance-corporation': 'federal-crop-insurance-corporation',
  'federal-deposit-insurance-corporation': 'federal-deposit-insurance-corporation',
  'federal-election-commission': 'federal-election-commission',
  'federal-emergency-management-agency': 'federal-emergency-management-agency',
  'federal-energy-regulatory-commission': 'federal-energy-regulatory-commission',
  'federal-financial-institutions-examination-council': 'federal-financial-institutions-examination-council',
  'federal-highway-administration': 'federal-highway-administration',
  'federal-housing-enterprise-oversight-office': 'federal-housing-enterprise-oversight-office',
  'federal-housing-finance-agency': 'federal-housing-finance-agency',
  'federal-housing-finance-board': 'federal-housing-finance-board',
  'federal-labor-relations-authority': 'federal-labor-relations-authority',
  'federal-law-enforcement-training-center': 'federal-law-enforcement-training-center',
  'federal-maritime-commission': 'federal-maritime-commission',
  'federal-mediation-and-conciliation-service': 'federal-mediation-and-conciliation-service',
  'federal-mine-safety-and-health-review-commission': 'federal-mine-safety-and-health-review-commission',
  'federal-motor-carrier-safety-administration': 'federal-motor-carrier-safety-administration',
  'federal-pay-advisory-committee': 'federal-pay-advisory-committee',
  'federal-permitting-improvement-steering-council': 'federal-permitting-improvement-steering-council',
  'federal-prison-industries': 'federal-prison-industries',
  'federal-procurement-policy-office': 'federal-procurement-policy-office',
  'federal-railroad-administration': 'federal-railroad-administration',
  'federal-register-office': 'federal-register-office',
  'federal-register-administrative-committee': 'federal-register-administrative-committee',
  'federal-reserve-system': 'federal-reserve-system',
  'federal-retirement-thrift-investment-board': 'federal-retirement-thrift-investment-board',
  'federal-service-impasses-panel': 'federal-service-impasses-panel',
  'federal-trade-commission': 'federal-trade-commission',
  'federal-transit-administration': 'federal-transit-administration',
  'financial-crimes-enforcement-network': 'financial-crimes-enforcement-network',
  'financial-crisis-inquiry-commission': 'financial-crisis-inquiry-commission',
  'financial-research-office': 'financial-research-office',
  'financial-stability-oversight-council': 'financial-stability-oversight-council',
  'first-responder-network-authority': 'first-responder-network-authority',
  'fiscal-service': 'fiscal-service',
  'fish-and-wildlife-service': 'fish-and-wildlife-service',
  'food-and-consumer-service': 'food-and-consumer-service',
  'food-and-drug-administration': 'food-and-drug-administration',
  'food-and-nutrition-service': 'food-and-nutrition-service',
  'food-safety-and-inspection-service': 'food-safety-and-inspection-service',
  'foreign-agricultural-service': 'foreign-agricultural-service',
  'foreign-assets-control-office': 'foreign-assets-control-office',
  'foreign-claims-settlement-commission': 'foreign-claims-settlement-commission',
  'foreign-service-grievance-board': 'foreign-service-grievance-board',
  'foreign-service-impasse-disputes-panel': 'foreign-service-impasse-disputes-panel',
  'foreign-service-labor-relations-board': 'foreign-service-labor-relations-board',
  'foreign-trade-zones-board': 'foreign-trade-zones-board',
  'forest-service': 'forest-service',
  'general-services-administration': 'general-services-administration',
  'geographic-names-board': 'geographic-names-board',
  'geological-survey': 'geological-survey',
  'government-accountability-office': 'government-accountability-office',
  'government-ethics-office': 'government-ethics-office',
  'government-national-mortgage-association': 'government-national-mortgage-association',
  'government-publishing-office': 'government-publishing-office',
  'grain-inspection-packers-and-stockyards-administration': 'grain-inspection-packers-and-stockyards-administration',
  'great-lakes-st-lawrence-seaway-development-corporation': 'great-lakes-st-lawrence-seaway-development-corporation',
  'gulf-coast-ecosystem-restoration-council': 'gulf-coast-ecosystem-restoration-council',
  'harry-s-truman-scholarship-foundation': 'harry-s-truman-scholarship-foundation',
  'health-and-human-services-department': 'health-and-human-services-department',
  'health-care-finance-administration': 'health-care-finance-administration',
  'health-resources-and-services-administration': 'health-resources-and-services-administration',
  'hearings-and-appeals-office-energy-department': 'hearings-and-appeals-office-energy-department',
  'hearings-and-appeals-office-interior-department': 'hearings-and-appeals-office-interior-department',
  'homeland-security-department': 'homeland-security-department',
  'housing-and-urban-development-department': 'housing-and-urban-development-department',
  'immigration-and-naturalization-service': 'immigration-and-naturalization-service',
  'indian-affairs-bureau': 'indian-affairs-bureau',
  'indian-arts-and-crafts-board': 'indian-arts-and-crafts-board',
  'indian-health-service': 'indian-health-service',
  'indian-trust-transition-office': 'indian-trust-transition-office',
  'industry-and-security-bureau': 'industry-and-security-bureau',
  'information-security-oversight-office': 'information-security-oversight-office',
  'inspector-general-office-agriculture-department': 'inspector-general-office-agriculture-department',
  'inspector-general-office-health-and-human-services-department': 'inspector-general-office-health-and-human-services-department',
  'institute-of-american-indian-and-alaska-native-culture-and-arts-development': 'institute-of-american-indian-and-alaska-native-culture-and-arts-development',
  'institute-of-museum-and-library-services': 'institute-of-museum-and-library-services',
  'intellectual-property-enforcement-coordinator-office': 'intellectual-property-enforcement-coordinator-office',
  'inter-american-foundation': 'inter-american-foundation',
  'interagency-floodplain-management-review-committee': 'interagency-floodplain-management-review-committee',
  'intergovernmental-relations-advisory-commission': 'intergovernmental-relations-advisory-commission',
  'interior-department': 'interior-department',
  'internal-revenue-service': 'internal-revenue-service',
  'international-boundary-and-water-commission-united-states-and-mexico': 'international-boundary-and-water-commission-united-states-and-mexico',
  'international-broadcasting-advisory-board': 'international-broadcasting-advisory-board',
  'international-broadcasting-board': 'international-broadcasting-board',
  'international-development-cooperation-agency': 'international-development-cooperation-agency',
  'u-s-international-development-finance-corporation': 'u-s-international-development-finance-corporation',
  'international-investment-office': 'international-investment-office',
  'international-joint-commission-united-states-and-canada': 'international-joint-commission-united-states-and-canada',
  'international-organizations-employees-loyalty-board': 'international-organizations-employees-loyalty-board',
  'international-trade-administration': 'international-trade-administration',
  'international-trade-commission': 'international-trade-commission',
  'interstate-commerce-commission': 'interstate-commerce-commission',
  'investment-security-office': 'investment-security-office',
  'james-madison-memorial-fellowship-foundation': 'james-madison-memorial-fellowship-foundation',
  'japan-united-states-friendship-commission': 'japan-united-states-friendship-commission',
  'joint-board-for-enrollment-of-actuaries': 'joint-board-for-enrollment-of-actuaries',
  'judicial-conference-of-the-united-states': 'judicial-conference-of-the-united-states',
  'judicial-review-commission-on-foreign-asset-control': 'judicial-review-commission-on-foreign-asset-control',
  'justice-department': 'justice-department',
  'justice-programs-office': 'justice-programs-office',
  'juvenile-justice-and-delinquency-prevention-office': 'juvenile-justice-and-delinquency-prevention-office',
  'labor-department': 'labor-department',
  'labor-statistics-bureau': 'labor-statistics-bureau',
  'labor-management-standards-office': 'labor-management-standards-office',
  'land-management-bureau': 'land-management-bureau',
  'legal-services-corporation': 'legal-services-corporation',
  'library-of-congress': 'library-of-congress',
  'local-television-loan-guarantee-board': 'local-television-loan-guarantee-board',
  'management-and-budget-office': 'management-and-budget-office',
  'marine-mammal-commission': 'marine-mammal-commission',
  'maritime-administration': 'maritime-administration',
  'medicare-payment-advisory-commission': 'medicare-payment-advisory-commission',
  'merit-systems-protection-board': 'merit-systems-protection-board',
  'military-compensation-and-retirement-modernization-commission': 'military-compensation-and-retirement-modernization-commission',
  'millennium-challenge-corporation': 'millennium-challenge-corporation',
  'mine-safety-and-health-administration': 'mine-safety-and-health-administration',
  'minerals-management-service': 'minerals-management-service',
  'mines-bureau': 'mines-bureau',
  'minority-business-development-agency': 'minority-business-development-agency',
  'minority-economic-impact-office': 'minority-economic-impact-office',
  'mississippi-river-commission': 'mississippi-river-commission',
  'monetary-offices': 'monetary-offices',
  'morris-k-udall-and-stewart-l-udall-foundation': 'morris-k-udall-and-stewart-l-udall-foundation',
  'national-aeronautics-and-space-administration': 'national-aeronautics-and-space-administration',
  'national-agricultural-library': 'national-agricultural-library',
  'national-agricultural-statistics-service': 'national-agricultural-statistics-service',
  'national-archives-and-records-administration': 'national-archives-and-records-administration',
  'national-assessment-governing-board': 'national-assessment-governing-board',
  'national-bankruptcy-review-commission': 'national-bankruptcy-review-commission',
  'national-biological-service': 'national-biological-service',
  'national-bipartisan-commission-on-future-of-medicare': 'national-bipartisan-commission-on-future-of-medicare',
  'national-capital-planning-commission': 'national-capital-planning-commission',
  'national-civilian-community-corps': 'national-civilian-community-corps',
  'national-commission-on-fiscal-responsibility-and-reform': 'national-commission-on-fiscal-responsibility-and-reform',
  'national-commission-on-intermodal-transportation': 'national-commission-on-intermodal-transportation',
  'national-commission-on-libraries-and-information-science': 'national-commission-on-libraries-and-information-science',
  'national-commission-on-manufactured-housing': 'national-commission-on-manufactured-housing',
  'national-commission-on-military-national-and-public-service': 'national-commission-on-military-national-and-public-service',
  'national-commission-on-terrorist-attacks-upon-the-united-states': 'national-commission-on-terrorist-attacks-upon-the-united-states',
  'national-commission-on-the-cost-of-higher-education': 'national-commission-on-the-cost-of-higher-education',
  'national-communications-system': 'national-communications-system',
  'national-consumer-cooperative-bank': 'national-consumer-cooperative-bank',
  'national-council-on-disability': 'national-council-on-disability',
  'national-counterintelligence-center': 'national-counterintelligence-center',
  'national-credit-union-administration': 'national-credit-union-administration',
  'national-crime-prevention-and-privacy-compact-council': 'national-crime-prevention-and-privacy-compact-council',
  'national-economic-council': 'national-economic-council',
  'national-education-goals-panel': 'national-education-goals-panel',
  'national-endowment-for-the-arts': 'national-endowment-for-the-arts',
  'national-endowment-for-the-humanities': 'national-endowment-for-the-humanities',
  'national-foundation-on-the-arts-and-the-humanities': 'national-foundation-on-the-arts-and-the-humanities',
  'national-gambling-impact-study-commission': 'national-gambling-impact-study-commission',
  'national-geospatial-intelligence-agency': 'national-geospatial-intelligence-agency',
  'national-highway-traffic-safety-administration': 'national-highway-traffic-safety-administration',
  'national-historical-publications-and-records-commission': 'national-historical-publications-and-records-commission',
  'national-indian-gaming-commission': 'national-indian-gaming-commission',
  'national-institute-for-literacy': 'national-institute-for-literacy',
  'national-institute-of-corrections': 'national-institute-of-corrections',
  'national-institute-of-food-and-agriculture': 'national-institute-of-food-and-agriculture',
  'national-institute-of-justice': 'national-institute-of-justice',
  'national-institute-of-standards-and-technology': 'national-institute-of-standards-and-technology',
  'national-institutes-of-health': 'national-institutes-of-health',
  'national-intelligence-office-of-the-national-director': 'national-intelligence-office-of-the-national-director',
  'national-labor-relations-board': 'national-labor-relations-board',
  'national-library-of-medicine': 'national-library-of-medicine',
  'national-mediation-board': 'national-mediation-board',
  'national-nanotechnology-coordination-office': 'national-nanotechnology-coordination-office',
  'national-nuclear-security-administration': 'national-nuclear-security-administration',
  'national-oceanic-and-atmospheric-administration': 'national-oceanic-and-atmospheric-administration',
  'national-park-service': 'national-park-service',
  'national-partnership-for-reinventing-government': 'national-partnership-for-reinventing-government',
  'national-prison-rape-elimination-commission': 'national-prison-rape-elimination-commission',
  'national-railroad-passenger-corporation': 'national-railroad-passenger-corporation',
  'national-science-foundation': 'national-science-foundation',
  'national-security-agency-central-security-service': 'national-security-agency-central-security-service',
  'national-security-commission-on-artificial-intelligence': 'national-security-commission-on-artificial-intelligence',
  'national-security-council': 'national-security-council',
  'national-shipping-authority': 'national-shipping-authority',
  'national-skill-standards-board': 'national-skill-standards-board',
  'national-space-council': 'national-space-council',
  'national-technical-information-service': 'national-technical-information-service',
  'national-telecommunications-and-information-administration': 'national-telecommunications-and-information-administration',
  'national-transportation-safety-board': 'national-transportation-safety-board',
  'national-women-s-business-council': 'national-women-s-business-council',
  'natural-resources-conservation-service': 'natural-resources-conservation-service',
  'natural-resources-revenue-office': 'natural-resources-revenue-office',
  'navajo-and-hopi-indian-relocation-office': 'navajo-and-hopi-indian-relocation-office',
  'navy-department': 'navy-department',
  'neighborhood-reinvestment-corporation': 'neighborhood-reinvestment-corporation',
  'northeast-dairy-compact-commission': 'northeast-dairy-compact-commission',
  'northeast-interstate-low-level-radioactive-waste-commission': 'northeast-interstate-low-level-radioactive-waste-commission',
  'northern-border-regional-commission': 'northern-border-regional-commission',
  'nuclear-energy-office': 'nuclear-energy-office',
  'nuclear-regulatory-commission': 'nuclear-regulatory-commission',
  'nuclear-waste-technical-review-board': 'nuclear-waste-technical-review-board',
  'occupational-safety-and-health-administration': 'occupational-safety-and-health-administration',
  'occupational-safety-and-health-review-commission': 'occupational-safety-and-health-review-commission',
  'ocean-energy-management-bureau': 'ocean-energy-management-bureau',
  'ocean-energy-management-regulation-and-enforcement-bureau': 'ocean-energy-management-regulation-and-enforcement-bureau',
  'ocean-policy-commission': 'ocean-policy-commission',
  'office-of-government-information-services': 'office-of-government-information-services',
  'office-of-motor-carrier-safety': 'office-of-motor-carrier-safety',
  'office-of-national-drug-control-policy': 'office-of-national-drug-control-policy',
  'office-of-policy-development': 'office-of-policy-development',
  'office-of-the-chief-financial-officer-agriculture-department': 'office-of-the-chief-financial-officer-agriculture-department',
  'office-of-the-national-cyber-director': 'office-of-the-national-cyber-director',
  'oklahoma-city-national-memorial-trust': 'oklahoma-city-national-memorial-trust',
  'operations-office': 'operations-office',
  'ounce-of-prevention-council': 'ounce-of-prevention-council',
  'overseas-private-investment-corporation': 'overseas-private-investment-corporation',
  'pacific-northwest-electric-power-and-conservation-planning-council': 'pacific-northwest-electric-power-and-conservation-planning-council',
  'panama-canal-commission': 'panama-canal-commission',
  'parole-commission': 'parole-commission',
  'partnerships-and-public-engagement-office': 'partnerships-and-public-engagement-office',
  'patent-and-trademark-office': 'patent-and-trademark-office',
  'peace-corps': 'peace-corps',
  'pension-and-welfare-benefits-administration': 'pension-and-welfare-benefits-administration',
  'pension-benefit-guaranty-corporation': 'pension-benefit-guaranty-corporation',
  'personnel-management-office': 'personnel-management-office',
  'physician-payment-review-commission': 'physician-payment-review-commission',
  'pipeline-and-hazardous-materials-safety-administration': 'pipeline-and-hazardous-materials-safety-administration',
  'postal-rate-commission': 'postal-rate-commission',
  'postal-regulatory-commission': 'postal-regulatory-commission',
  'postal-service': 'postal-service',
  'president-s-council-on-integrity-and-efficiency': 'president-s-council-on-integrity-and-efficiency',
  'president-s-council-on-sustainable-development': 'president-s-council-on-sustainable-development',
  'president-s-critical-infrastructure-protection-board': 'president-s-critical-infrastructure-protection-board',
  'president-s-economic-policy-advisory-board': 'president-s-economic-policy-advisory-board',
  'presidential-advisory-committee-on-gulf-war-veterans-illnesses': 'presidential-advisory-committee-on-gulf-war-veterans-illnesses',
  'presidential-commission-on-assignment-of-women-in-the-armed-forces': 'presidential-commission-on-assignment-of-women-in-the-armed-forces',
  'presidio-trust': 'presidio-trust',
  'prisons-bureau': 'prisons-bureau',
  'privacy-and-civil-liberties-oversight-board': 'privacy-and-civil-liberties-oversight-board',
  'procurement-and-property-management-office-of': 'procurement-and-property-management-office-of',
  'program-support-center': 'program-support-center',
  'prospective-payment-assessment-commission': 'prospective-payment-assessment-commission',
  'public-buildings-reform-board': 'public-buildings-reform-board',
  'public-debt-bureau': 'public-debt-bureau',
  'public-health-service': 'public-health-service',
  'railroad-retirement-board': 'railroad-retirement-board',
  'reagan-udall-foundation-for-the-food-and-drug-administration': 'reagan-udall-foundation-for-the-food-and-drug-administration',
  'reclamation-bureau': 'reclamation-bureau',
  'recovery-accountability-and-transparency-board': 'recovery-accountability-and-transparency-board',
  'refugee-resettlement-office': 'refugee-resettlement-office',
  'regulatory-information-service-center': 'regulatory-information-service-center',
  'research-and-innovative-technology-administration': 'research-and-innovative-technology-administration',
  'research-and-special-programs-administration': 'research-and-special-programs-administration',
  'resolution-trust-corporation': 'resolution-trust-corporation',
  'risk-management-agency': 'risk-management-agency',
  'rural-business-cooperative-service': 'rural-business-cooperative-service',
  'rural-housing-and-community-development-service': 'rural-housing-and-community-development-service',
  'rural-housing-service': 'rural-housing-service',
  'rural-telephone-bank': 'rural-telephone-bank',
  'rural-utilities-service': 'rural-utilities-service',
  'safety-and-environmental-enforcement-bureau': 'safety-and-environmental-enforcement-bureau',
  'saint-lawrence-seaway-development-corporation': 'saint-lawrence-seaway-development-corporation',
  'science-and-technology-policy-office': 'science-and-technology-policy-office',
  'secret-service': 'secret-service',
  'securities-and-exchange-commission': 'securities-and-exchange-commission',
  'selective-service-system': 'selective-service-system',
  'small-business-administration': 'small-business-administration',
  'smithsonian-institution': 'smithsonian-institution',
  'social-security-administration': 'social-security-administration',
  'southeastern-power-administration': 'southeastern-power-administration',
  'southwestern-power-administration': 'southwestern-power-administration',
  'special-counsel-office': 'special-counsel-office',
  'special-inspector-general-for-afghanistan-reconstruction': 'special-inspector-general-for-afghanistan-reconstruction',
  'special-inspector-general-for-iraq-reconstruction': 'special-inspector-general-for-iraq-reconstruction',
  'special-trustee-for-american-indians-office': 'special-trustee-for-american-indians-office',
  'state-department': 'state-department',
  'state-justice-institute': 'state-justice-institute',
  'strategic-preparedness-and-response-administration': 'strategic-preparedness-and-response-administration',
  'substance-abuse-and-mental-health-services-administration': 'substance-abuse-and-mental-health-services-administration',
  'surface-mining-reclamation-and-enforcement-office': 'surface-mining-reclamation-and-enforcement-office',
  'surface-transportation-board': 'surface-transportation-board',
  'susquehanna-river-basin-commission': 'susquehanna-river-basin-commission',
  'technology-administration': 'technology-administration',
  'tennessee-valley-authority': 'tennessee-valley-authority',
  'the-white-house-office': 'the-white-house-office',
  'thrift-depositor-protection-oversight-board': 'thrift-depositor-protection-oversight-board',
  'thrift-supervision-office': 'thrift-supervision-office',
  'trade-and-development-agency': 'trade-and-development-agency',
  'trade-representative-office-of-united-states': 'trade-representative-office-of-united-states',
  'transportation-department': 'transportation-department',
  'transportation-office': 'transportation-office',
  'transportation-security-administration': 'transportation-security-administration',
  'transportation-statistics-bureau': 'transportation-statistics-bureau',
  'travel-and-tourism-administration': 'travel-and-tourism-administration',
  'treasury-department': 'treasury-department',
  'twenty-first-century-workforce-commission': 'twenty-first-century-workforce-commission',
  'u-s-citizenship-and-immigration-services': 'u-s-citizenship-and-immigration-services',
  'us-codex-office': 'us-codex-office',
  'u-s-committee-on-the-marine-transportation-system': 'u-s-committee-on-the-marine-transportation-system',
  'u-s-customs-and-border-protection': 'u-s-customs-and-border-protection',
  'u-s-house-of-representatives': 'u-s-house-of-representatives',
  'u-s-immigration-and-customs-enforcement': 'u-s-immigration-and-customs-enforcement',
  'u-s-trade-deficit-review-commission': 'u-s-trade-deficit-review-commission',
  'u-s-china-economic-and-security-review-commission': 'u-s-china-economic-and-security-review-commission',
  'under-secretary-for-economic-affairs': 'under-secretary-for-economic-affairs',
  'unified-carrier-registration-plan': 'unified-carrier-registration-plan',
  'uniformed-services-university-of-the-health-sciences': 'uniformed-services-university-of-the-health-sciences',
  'african-development-foundation': 'african-development-foundation',
  'united-states-agency-for-global-media': 'united-states-agency-for-global-media',
  'united-states-enrichment-corporation': 'united-states-enrichment-corporation',
  'united-states-information-agency': 'united-states-information-agency',
  'united-states-institute-of-peace': 'united-states-institute-of-peace',
  'united-states-marshals-service': 'united-states-marshals-service',
  'united-states-mint': 'united-states-mint',
  'united-states-olympic-and-paralympic-committee': 'united-states-olympic-and-paralympic-committee',
  'united-states-sentencing-commission': 'united-states-sentencing-commission',
  'utah-reclamation-mitigation-and-conservation-commission': 'utah-reclamation-mitigation-and-conservation-commission',
  'valles-caldera-trust': 'valles-caldera-trust',
  'veterans-affairs-department': 'veterans-affairs-department',
  'veterans-employment-and-training-service': 'veterans-employment-and-training-service',
  'victims-of-crime-office': 'victims-of-crime-office',
  'wage-and-hour-division': 'wage-and-hour-division',
  'western-area-power-administration': 'western-area-power-administration',
  'women-s-business-enterprise-interagency-committee': 'women-s-business-enterprise-interagency-committee',
  'women-s-progress-commemoration-commission': 'women-s-progress-commemoration-commission',
  'women-s-suffrage-centennial-commission': 'women-s-suffrage-centennial-commission',
  'workers-compensation-programs-office': 'workers-compensation-programs-office',
} as const;
